import { effect, Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SocketService {
  private socket: Socket;

  constructor(private authService: AuthService) {
    // Conectar no construtor não bastava: depois de um F5 a sessão volta
    // pelo cookie de atualização, e nesse instante o usuário ainda é nulo —
    // o socket nunca conectava e um boleto compensado dias depois só
    // aparecia com nova consulta. Reagir ao sinal do usuário cobre login,
    // recarga de página e troca de conta.
    effect(() => {
      const user = this.authService.getUserSignal()();
      if (user?.id) this.connect();
      else this.disconnect();
    });
  }

  public connect() {
    const user = this.authService.getCurrentUser();
    if (!user || !user.id) return;
    if (this.socket?.connected) return;

    // Conecta ao gateway do backend passando o ID do usuário
    this.socket = io(environment.base_graphql.replace('/graphql', ''), {
      query: { userId: user.id },
      transports: ['websocket']
    });

    this.socket.on('connect', () => {

    });

    // Escutando notificações em tempo real
    this.socket.on('new_notification', (data: any) => {

      
      // Exibe um toast luxuoso para o dentista
      Swal.fire({
        toast: true,
        position: 'top-end',
        icon: 'success',
        title: data.title,
        text: data.message,
        showConfirmButton: false,
        timer: 8000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
      });
      
      // Emitir um evento local para atualizar o sino de notificações se precisar
      document.dispatchEvent(new CustomEvent('update_notification_badge'));
    });

    // Saldo de créditos mudou (compra confirmada, débito na aprovação,
    // ajuste do admin). A tela não recarrega sozinha: quem ouve é o
    // CreditService, que refaz a consulta de saldo.
    this.socket.on('credit_balance_updated', (data: any) => {
      document.dispatchEvent(
        new CustomEvent('credit_balance_updated', { detail: data }),
      );
    });

    // Pagamento de uma compra de créditos confirmado pelo gateway. Chega
    // mesmo com o dentista fora da tela de pagamento (boleto compensa dias
    // depois), então quem ouve decide o que mostrar.
    this.socket.on('credit_purchase_paid', (data: any) => {
      document.dispatchEvent(
        new CustomEvent('credit_purchase_paid', { detail: data }),
      );
    });

    // Cobrança vencida, cancelada, recusada ou compra estornada.
    this.socket.on('credit_purchase_updated', (data: any) => {
      document.dispatchEvent(
        new CustomEvent('credit_purchase_updated', { detail: data }),
      );
    });

    this.socket.on('disconnect', () => {

    });
  }

  public disconnect() {
    if (this.socket) {
      this.socket.disconnect();
    }
  }
}
